module.exports = __webpack_public_path__ + "img/overview.1157fd6d.png";